import { getEventsList } from 'app/modules/claim/service/store/selectors';
import { FMIPResponse } from 'app/modules/claim/ui/tools/constants';
import { hasAnyAuthority } from '../auth/private-route';
import { AUTHORITIES } from '../config/constants';
import { isEmptyObject } from './methode-util';

/* eslint-disable complexity */
export function Constraint(constraintKey: string, state: any, constraintValue: boolean) {

  const results = { constaraint: constraintKey, disabled: false, show: true,showPopup:false };

  switch (constraintKey) {
    case 'STRUCT_DECLARE_CLAIM_IBAN_NOT_NULL':
      if (constraintValue) {
        const authorities = state?.accountState?.authorities;
        const sellingPointConnectedState = state?.sellingPointConnectedState;
        results.showPopup =
          sellingPointConnectedState?.details[0]?.bankInfos?.iban === null ||
          sellingPointConnectedState?.details[0]?.bankInfos?.iban === undefined ||
          sellingPointConnectedState?.details[0]?.bankInfos?.iban === '';
      } else {
        return results;
      }
      return results;
    case 'STRUCT_DECLARE_CLAIM_IS_NOT_MANAGER':
      if (constraintValue) {
        const authorities = state?.accountState?.authorities;
        results.showPopup =
          Object.keys(state?.accountState || {})?.length !== 0 ? hasAnyAuthority([AUTHORITIES.IBAN_WRITE], authorities) : false;
      } else {
        return results;
      }
      return results;
    case 'STRUCT_DECLARE_CLAIM_SUBSCRIPTION_SELING_POINT_CONNECTED':
      if (constraintValue) {
        const insuredGood = state?.subscriptionState?.insuredGoods.filter(e => e.active === true);
        const purchaseStore = insuredGood ? insuredGood[0]?.purchaseStore?.code : '';

        const sellingPointConnectedState = state?.sellingPointConnectedState;
        results.showPopup = purchaseStore !== sellingPointConnectedState?.code?.toString();
      }
      return results;

    case 'STRUCT_GEOLOCATION_CHECK_BUTTON':
      if (constraintValue) {
        const { logisticState } = state;
        const { bonTransportConstraint, geolocalisation } = logisticState || {};
        results.show = (
          bonTransportConstraint?.existBonTransport &&
          (
            !geolocalisation ||
            geolocalisation?.status === FMIPResponse.AVAILABLE ||
            (
              geolocalisation?.status !== FMIPResponse.NOCONTROLE &&
              geolocalisation?.status !== FMIPResponse.MAX_ATTEMPTS_REACHED &&
              geolocalisation?.status !== FMIPResponse.DISABLED &&
              geolocalisation?.attempts < 3
            )
          )
        );
      }
      return results;

    case 'STRUCT_DOWNLOAD_BP_BUTTON':
      if (constraintValue) {
        const { logisticState, claimState } = state;
        const { claim } = claimState?.claimModel || {};
        const { bonTransportConstraint, geolocalisation } = logisticState || {};
        const brand = claim?.damagedGoods[0]?.brand || "";
        const model = claim?.damagedGoods[0]?.model || "";
        const isApple = brand?.toUpperCase() === 'APPLE' || model?.toUpperCase().includes('IPHONE');
        const events = getEventsList(claimState);
        const eventDownload = events?.find((item) => (item?.code === 9));
        if (bonTransportConstraint) {
          results.show = (bonTransportConstraint?.existBonTransport &&
            (!isApple ||
              (isApple &&
                (!geolocalisation ||
                  geolocalisation?.status === FMIPResponse.AVAILABLE ||
                  geolocalisation?.status === FMIPResponse.DISABLED ||
                  (
                    geolocalisation?.status !== FMIPResponse.MAX_ATTEMPTS_REACHED &&
                    geolocalisation?.attempts < 3
                  )
                )
              )
            )
          );
          results.disabled = (isApple && isEmptyObject(eventDownload) && geolocalisation?.status !== FMIPResponse.DISABLED);
          return results;
        }
      }
      return results;

    case 'STRUCT_REDIRECT_EVENTS':
      if (constraintValue) {
        const events = state?.eventState;
        if (events && events?.length !== 0) {
          results.show = true;
        } else {
          results.show = false;
        }
      }

      return results;

    case 'SELLING_POINT_CLAIM_MANAGEMENT_CONSTRAINT':
      if (constraintValue) {
        const claimDetailsSellingPointCode = state?.claimState?.claimModel?.claim?.damagedGoods[0]?.sellingPoint?.code;
        if (claimDetailsSellingPointCode) {
          if (state?.sellingPointState?.connectedSellingPoint?.code === claimDetailsSellingPointCode) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return constraintValue;
      }
    case 'STRUCT_DOCUMENT_PENDING':
      if (constraintValue) {
        const listDocsToUpload = state?.docState;

        if (listDocsToUpload?.length) {
          listDocsToUpload.filter(el => el?.refDocumentReceptionStatus?.code === 7 || el?.refDocumentReceptionStatus?.code === 6)?.length
            ? (results.show = true)
            : (results.show = false);

          return results;
        } else {
          results.show = false;
          return results;
        }
      } else {
        return constraintValue;
      }
    case 'STRUCT_REDIRECT_TO_COTISATION':
      if (
        state.listImpyeState.length !== 0 &&
        (state.subscriptionState?.status === 'VALIDATED' ||
          state.subscriptionState?.status === 'PENDING' ||
          state.subscriptionState?.status === 'SUSPENDED')
      ) {
        results.show = true;
      } else {
        results.show = false;
      }
      return results;
    default:
      return false;
  }
}

export function ConstraintActionParam(constraintKey: string, actionDataList: any, constraintValue: string) {
  const dataConfParam = actionDataList?.find(e => (e.actionDataKey = constraintKey))?.params;
  switch (constraintValue) {
    case 'SAVE_IP': {
      return dataConfParam?.SAVE_IP;
    }
    case 'CHECK_BY_EMAIL': {
      return dataConfParam?.CHECK_BY_EMAIL;
    }
    case 'CHECK_BY_SMS': {
      return dataConfParam?.CHECK_BY_SMS;
    }
    case 'CHECK_BY_IBAN': {
      return dataConfParam?.CHECK_BY_IBAN;
    }
    case 'CHECK_BY_IMEI': {
      return dataConfParam?.CHECK_BY_IMEI;
    }
    default:
      return false;
  }
}
